<template>
  <div class="widthFull fitAvailableHeight somatoline">
    <loading v-if="loading" />

    <div class="container-fluid mt-5 pt-5">
      <div class="row mt-0 mt-lg-5 pt-5 center">
        <h1 v-if="!state" class="text-red Medium widthFull">
          <span>Crea nuova password</span>
        </h1>
      </div>
    </div>

    <div class="container-fluid">
      <form
        class="recovery-password"
        id="recovery-form"
        @submit.prevent="recovery"
      >
        <div v-if="!state">
          <div class="form-row justify-content-center">
            <div class="col-md-4">
              <label for="password" class="widthFull text-center"> </label>
              <div class="group mt-5">
                <input
                  type="password"
                  v-model="password"
                  class="form-control mt-1"
                  id="password"
                  name="password"
                  v-validate="{
                    required: true,
                    passwordCheck: true,
                    min: 8,
                    max: 56,
                  }"
                  :class="{
                    'is-invalid': errors.has('password'),
                    valid: !!password,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="password"
                  >Nuova Password</label
                >

                <div v-if="errors.has('password')" class="invalid-feedback">
                  {{ errors.first("password") }}
                </div>
              </div>
              <div class="group mt-5">
                <input
                  type="password"
                  v-model="confirm_password"
                  class="form-control mt-3"
                  id="confirm_password"
                  name="confirm_password"
                  data-vv-as="conferma password"
                  v-validate="{
                    required: !!password,
                  confirmed: password,
                  passwordCheck: true,
                    min: 8,
                    max: 56,
                  }"
                  :class="{
                    'is-invalid': errors.has('confirm_password'),
                    valid: !!confirm_password,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="password"
                  >Conferma Nuova Password</label
                >

                <div
                  v-if="errors.has('confirm_password')"
                  class="invalid-feedback"
                >
                  {{ errors.first("confirm_password") }}
                </div>
                <div v-if="error" class="mt-3">
                  <span class="formError ml-1">{{ error }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="col-md-6 mb-3 mt-5 text-center">
              <button class="btn btn-primary" type="submit">CONFERMA</button>
            </div>
          </div>
        </div>
        <div v-else="!state">
          <div class="form-row justify-content-center">
            <div class="col-md-6 mb-5 mt-5 back-white">
              <h4 for="email" class="center widthFull Medium" role="alert">
                <p>La password è stata aggiornata correttamente,</p>
                <p>adesso puoi accedere utilizzando la tua nuova password..</p>
              </h4>
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="col-md-6 mb-3 text-center">
              <router-link class="btn btn-primary" to="/login"
                >Accedi</router-link
              >
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { AUTH_REQUEST } from "actions/auth";
import { mapGetters, mapState } from "vuex";
import axios from "axios";

export default {
  name: "recoverypassword",
  data() {
    return {
      password: "",
      confirm_password: "",
      state: false,
      error: "",
      loading: false,
    };
  },
  methods: {
    recovery: function () {
      const { password, confirm_password } = this;
      const token = this.$route.query.token;

      this.$validator.validate().then((valid) => {
        if (valid && token) {
          this.loading = true;
          var data = {
            password: password,
            token: token,
						 id_platform: process.env.ID_PLATFORM,
            unique_key_db: process.env.UNIQUE_KEY_DB,
            vector_unique_key_db: process.env.ICODE,
          };
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          axios({
            url: process.env.ROOT_API + "api/changePassword",
            data: {
              data,
            },
            method: "POST",
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
          })
            .then((resp) => {
              this.state = true;
              this.loading = false;
            })
            .catch((resp) => {
              this.state = false;
              this.error = process.env.TOKEN_NOT_EXIST;
              this.loading = false;
            });
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "loginerror",
      "loadingState",
      "isAuthenticated",
      "isProfileLoaded",
    ]),
    ...mapState({
      //login_error: state => `${state.login_error}`,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/recoverypassword/index.vue